import {createIcons, type IconNode} from "lucide";

// 各页面只处理尚未渲染且由自身提供的图标，保持已显示的 SVG 不变。
export function renderIcons(icons: Record<string, IconNode>): void {
  const supported = new Set(Object.keys(icons).map((name) => name
    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
    .replace(/([a-zA-Z])([0-9])/g, "$1-$2").toLowerCase()));
  const pending = [...document.querySelectorAll<HTMLElement>("i[data-lucide]")]
    .filter((element) => supported.has(element.dataset.lucide ?? ""));
  if (!pending.length) return;
  pending.forEach((element) => {
    element.setAttribute("data-pending-icon", element.dataset.lucide!);
  });
  createIcons({icons, nameAttr: "data-pending-icon"});
  document.querySelectorAll("[data-pending-icon]").forEach((element) => {
    element.removeAttribute("data-pending-icon");
  });
}
